import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { RenderIn, device } from '../../utils/RenderIn';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import styles from './HpRespModuleContainer.scss';

function HpSharedModuleHeader({ title, subtitle }) {
    return title ? (
        <Fragment>
            <RenderIn deviceTypes={[device.DESKTOP, device.TABLET]}>
                <BarHeader title={title} size="xLarge" htmlElementType="h2" subtitle={subtitle} />
            </RenderIn>
            <RenderIn deviceTypes={[device.MOBILE]}>
                <PageLayout setOffset={false} setViewportBackground={'transparent'}>
                    <BarHeader title={title} htmlElementType="h2" subtitle={subtitle} />
                </PageLayout>
            </RenderIn>
        </Fragment>
    ) : null;
}

HpSharedModuleHeader.propTypes = {
    title: PropTypes.node,
    subtitle: PropTypes.node,
};

function HpSharedModuleSubHeader({ children }) {
    return children ? <h2 className={styles.subHeader}>{children}</h2> : null;
}

HpSharedModuleSubHeader.propTypes = {
    children: PropTypes.node,
};

class HpRespModuleContainer extends Component {
    static Header = HpSharedModuleHeader;

    static SubHeader = HpSharedModuleSubHeader;

    render() {
        return (
            <div
                data-tn={this.props.dataTn}
                className={classnames(
                    { [styles.addTopGap]: this.props.addTopGap },
                    this.props.className
                )}
            >
                {this.props.children}
            </div>
        );
    }
}

HpRespModuleContainer.propTypes = {
    children: PropTypes.node,
    addTopGap: PropTypes.bool,
    className: PropTypes.string,
    dataTn: PropTypes.string,
};

HpRespModuleContainer.defaultProp = {
    addTopGap: false,
    className: null,
    dataTn: '',
};

export { HpRespModuleContainer };
